import { DEFAULT_API_SERVICE_URI } from 'API/consts';
import { RESTResource } from '../RESTResource';
/* eslint-disable @typescript-eslint/indent */
export default new RESTResource((urlParams) => {
    var _a;
    const urlRoot = (_a = process.env.GN_SERVICE_URI) !== null && _a !== void 0 ? _a : DEFAULT_API_SERVICE_URI;
    const { pfamDomainId } = urlParams;
    return `${urlRoot}/pfam/domain/${pfamDomainId}`;
});
